import type {
  MerchantDataProps,
  MerchantProps,
} from '@/entities/merchant/model/types.ts';

export enum MediationStatus {
  Pending = 'pending',
  Signed = 'signed',
}

export interface MediationDocumentProps {
  label: string;
  size: number;
  url: string;
}

export interface ScheduleProps {
  id: number;
  amount: string;
  paid_at: string | null;
  payment_date: string;
  status: number;
  status_label: string;
}

export interface MediationProps {
  amount: string;
  created_at: string;
  documents?: MediationDocumentProps[];
  expires_at: null;
  external_mediation_id: string;
  id: number;
  loan_id: null;
  merchant: MerchantProps;
  merchant_data: MerchantDataProps;
  payment_schedules: ScheduleProps[];
  signed_at: string | null;
  status: MediationStatus;
  status_label: string;
}
